import { ClusterState } from "@/components/PageCluster/redux/types";

export const clusterInitialState: ClusterState = {
  clusterData: null,
  error: null,
  loading: false,
  ua: undefined,
  clusterSlug: null,
};
